import { render, staticRenderFns } from "./orderDespatchBreakdownWidget.vue?vue&type=template&id=d6b32ffa&"
import script from "./orderDespatchBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./orderDespatchBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports